module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "status-alerts"
  }, _vm._l((_vm.alerts), function(alert) {
    return _c('span', {
      key: alert.id,
      class: 'alert ' + (alert.type ? alert.type : 'alert-info-text') + ' blink'
    }, [_c('strong', [_vm._v(_vm._s(alert.title))]), _vm._v(" "), (alert.message) ? _c('strong', [_vm._v("- " + _vm._s(alert.message))]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54486778","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ocean-insights/StatusAlerts.vue
// module id = 2636
// module chunks = 0